module.exports = __webpack_public_path__ + "media/3_3-5.bea7dab2.mp3";